<template>
  <div class="footer-container">

    <div class="disclaimer">
        <div class="container">
            <p>
                <b>Disclaimer of Warranties:</b> The Horti Light Calculator (“<b>Tool</b>”), the content (including, without limitation, text, images, graphics, links and other materials) of the Tool (“<b>Content</b>”) and results generated by using the Tool (“<b>Calculated Results</b>”) are provided “as is” and “as available”. Your use of the Tool, the Content and the Calculated Results are further subject to the <a href="https://www.signify.com/global/terms-of-use">Terms of Use</a>. Neither Signify, nor its affiliates, partners, licensors and suppliers warrants or makes any representation that (i) the Tool will be uninterrupted, timely, secure or error free, or (ii) the Content and/or Calculated Results will be correct, complete, accurate, reliable fit for your particular purpose or otherwise meet your requirements.
            </p>
        </div>
    </div>
  </div>
</template>

<script>
import rightArrowIcon from "@/assets/icons/horti_03-right-12px.svg?inline";
import { groupBy, debounce } from 'lodash';

function noBorder() {
  const navElementsNoBorder = [...document.querySelectorAll('.footer-links-list > li.no-border')];
    navElementsNoBorder.map(el => el.classList.remove('no-border'));

    const navElements = [...document.querySelectorAll('.footer-links-list > li')];
    Object.values(groupBy(navElements, 'offsetTop'))
          .forEach(item => item[0].classList.add('no-border'));
}

export default {
  name: "Footer",
  components: {rightIcon: rightArrowIcon},
  mounted() {
    window.addEventListener('resize', this.noBorderDebounced);
    this.noBorderDebounced();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.noBorderDebounced);
  },
  methods: {
    noBorderDebounced: debounce(noBorder, 250),
  },
  watch: {
    '_i18n.locale': {
      handler: function() {
        this.noBorderDebounced();
      }
    }
  }
}
</script>

<style lang="scss">

  %elements-alignment {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  %text-decoration {
    color: $white;
    font-size: 14px;
  }
  
  .footer-container {
    flex: 0 0 auto;
  }

  .page-footer {
    background-image: linear-gradient(to bottom right, $purple-700, $pink-700);
    padding: 40px 0;
    
  }

  .social-group {
    @extend %elements-alignment;

    p {
      @extend %text-decoration;
      margin-bottom: 0;
      font-weight: normal;
    }
    .social-item {
      font-size: 27px;
      color: $white;
      margin-right: 10px;
      cursor: pointer;

      :last-child {
        margin-right: 0;
      }

      &:hover {
        color: $purple-100;
      }
    }
  }

  .logo {
    @extend %elements-alignment;
  }

  .locale-selector {
    @extend %elements-alignment;
  }

  .selector {
    color: $white;

    .selector-country {
      color: $purple-100;
    }

    .selector-arrow {
      $size: 10px;
      width: $size;
      height: $size;
    }

    &:hover {
      color: $purple-100;
      text-decoration: none;
    }

    #Right-arrow {
      fill: #fff;
    }
  }

  .footer-nav {
    @extend %text-decoration;
    text-align: center;
    margin-top: 50px;
  }

  .footer-links-list {
    list-style-type: none;
    padding: 0;

    li {
      display: inline-block;
      padding: 0 7px;
      border-left: 1px solid #fff;
      line-height: 15px;

      a {
        color: $white;
        font-size: 14px;
      }

      :hover {
        color: $purple-100;
        text-decoration: none;
      }
    }

    .no-border {
      border-left: none;
    }
  }

  .copyright {
    @extend %text-decoration;
    text-align: center;
  }

  @media only screen and (max-width: 767px) {
      .col {
        flex: none;
        margin-bottom: 30px;
        justify-content: center;
      }

      .logo {
        order: -1;
      }

      .footer-nav {
        margin-top: 0;
      }
    }

  @media only screen and (max-width: 480px) {
    .footer-nav {
      padding: 0 5px;
    }
  }

</style>
